import { toLower } from 'lodash-es'

import envRaw from './env-raw'
import MapArray from './map-array'
import extractRawElm from './extract-raw-elm'

import { getElmSign } from './get-elm-str'
import { offEvent, onEventPassive } from './on-event.js'

const eventName = 'transitionend'
export const input2handler = MapArray()
input2handler.setMaxPairs(250)

export function onceTransitionEnd($elm, propertyName, sourceHandler) {
  return _onTransitionEnd(true, $elm, propertyName, sourceHandler)
}

export function onTransitionEnd($elm, propertyName, sourceHandler) {
  return _onTransitionEnd(false, $elm, propertyName, sourceHandler)
}

function _onTransitionEnd(once, $elm, rawPropertyName, sourceHandler) {
  const propertyName = toLower(rawPropertyName)
  const elm = relaxedExtractRawElm($elm)
  const input = [elm, propertyName, sourceHandler]
  const registered = input2handler.has(input)

  if (!registered) {
    const myHandler = makeHandler(once, $elm, propertyName, sourceHandler)
    input2handler.set(input, myHandler)
    onEventPassive(elm, eventName, myHandler)
  }

  return $elm
}

export function offTransitionEnd($elm, rawPropertyName, sourceHandler) {
  const propertyName = toLower(rawPropertyName)
  const elm = relaxedExtractRawElm($elm)
  const input = [elm, propertyName, sourceHandler]
  const keyIndex = input2handler.getIndex(input)

  if (keyIndex !== -1) {
    const myHandler = input2handler.getByIndex(keyIndex)
    input2handler.delByIndex(keyIndex)
    offEvent(elm, eventName, myHandler)
  }

  return $elm
}

function makeHandler(once, $elm, propertyName, sourceHandler) {
  const elm = relaxedExtractRawElm($elm)
  return function myHandler(event) {
    const sameElement = elm === event.target
    const sameProperty = toLower(event.propertyName).indexOf(propertyName) !== -1
    if (sameElement && sameProperty) {
      if (once) {
        offEvent($elm, eventName, myHandler)
        input2handler.delByValue(myHandler)
      }
      if (envRaw.showsTransitionDebug) {
        const eventSign = event.propertyName
        const targetSign = getElmSign(event.target)
        const repeatMark = once ? 'once' : 'on'
        console.debug(`${Date.now()} !onTransitionEnd "${eventSign}" ${repeatMark} "${targetSign}"`)
      }
      return sourceHandler(event)
    }
  }
}

function relaxedExtractRawElm($elm) {
  return $elm === window ? $elm : extractRawElm($elm)
}
